import React, { useState, useEffect } from 'react';
import AdminNavbar from '../Navbar/AdminNavbar';
import UserNavbar from '../Navbar/UserNavbar';
import { Button, Input, Select, Table ,DatePicker, Tooltip, Spin } from "antd";
import { AiFillAccountBook } from "react-icons/ai";
import { ProductMasterFindAll, RateMasterAdd, RateMasterAdDelete, RateMasterAdUpdate, RateMasterFindAll } from '../Api/All_Api';
import axios from "axios";
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import TitleNavbar from '../Navbar/TitleNavbar';

const RateMaster = () => {
  const role = sessionStorage.getItem('role');
 const branchId = sessionStorage.getItem('branchId');
   const sessionYear = sessionStorage.getItem('sessionYear');
 const navigate = useNavigate();
     useEffect(() => {
       if (!sessionYear) {
         sessionStorage.clear();
         navigate('/')
       }
     },[])

  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY"];
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [products, setProducts] = useState([]);
  const [alldata, setAllData] = useState([]);

  const [errors, setErrors] = useState({
    product: '',
    rateDate:'',
    rate:'',

  });


const [filteredData, setFilteredData] = useState([]);

const[allRate , setAllRate]=useState([]);
const [rateId, setRateId] = useState('');
const [rateDate, setRateDate] = useState(null);
const [product, setProduct] = useState('');
const [rate, setRate] = useState('');
const [loading, setLoading] = useState(false);
const [updateButton, setUpdateButton] = useState(false);
const [saveButton, setSaveButton] = useState(true);

const handleSearch = (value) => {
  const filtered = alldata.filter((item) =>
    Object.values(item).some((val) =>
      val?.toString().toLowerCase().includes(value.toLowerCase())
    )
  );
  setFilteredData(filtered);
  setTotalEntries(filtered.length); // Update total entries count after filtering
  setCurrentPage(1);
};
//==========Pagination=======================
const handlePageSizeChange = (value) => {
  setPageSize(value);
};
  const handleCancel = () => {
    setUpdateButton(false);
    setSaveButton(true);
    setRate('');
    setRateDate('');
    setProduct('');
    setErrors('');
    fetchRate();
  };
  useEffect(() => {
    fetchRate();
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${ProductMasterFindAll}?branchId=${branchId}`);
      if (response.data) {
        setProducts(response.data);
     
       
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to fetch product data');
    }
  };

  // ========Submit data to table==============
  const handleSubmit = async () => {
    let isValid=true;
    const errorObj = {};
    if (!product) {
      isValid = false;
      errorObj.product = "Product is required *";
    }
    if (!rate) {
      isValid = false;
      errorObj.rate = "Rate is required *";
    }
    if (!rateDate) {
      isValid = false;
      errorObj.rateDate = "Date is required *";
    }
    setErrors(errorObj); // Set error messages

    if (!isValid) return;
    const rateValue = parseFloat(rate);
    if (isNaN(rateValue)) {
      setErrors("Invalid rate value.");
      return;
    }
    setLoading(true);
    const formattedDate = rateDate && dayjs(rateDate).isValid()
  ? dayjs(rateDate).format("YYYY-MM-DD")
  : "";
    const bodyData ={
     productId : product,
   price: rateValue,
      date : formattedDate,
      branchId:parseInt(branchId),
    }

    try {
      const response = await axios.post(RateMasterAdd,bodyData );

      if (response.data === "CREATED") {
        toast.success('Rate added successfully!');
        fetchRate();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
        toast.warn('Rate already exist!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while submitting data');
    }
    finally{
      setLoading(false);
    }
  };

  // ========Update data from table============
  const handleEditDataButton = (item) => {
    setUpdateButton(true);
    setSaveButton(false);
    window.scrollTo(0, 0);
    setRate(item.price);
    setRateId(item.id);
    setProduct(item.productId);
    setRateDate(item.date);

  };

  let isError = false;
  const fetchRate = async () => {
    try {
      const response = await axios.get(`${RateMasterFindAll}?branchId=${parseInt(branchId)}`);
      if (response.data !== null) {
        setAllData(response.data);
        setFilteredData(response.data); // Set initial filtered data as the fetched data
        setTotalEntries(response.data.length); // Set the total number of entries
      }
      
    } catch (error) {
        if (!isError) {  // Check if the error has already been triggered
          console.error('Error fetching Rate:', error);
          toast.error('Failed to fetch rate data');
          isError = true;  // Set the flag to prevent double toast
        }
    }
  };   
  const handleUpdate = async () => {
    let isValid=true;
    const errorObj = {};
    if (!product) {
      isValid = false;
      errorObj.product = "Product is required *";
    }
    if (!rate) {
      isValid = false;
      errorObj.rate = "Rate is required *";
    }
    if (!rateDate) {
      isValid = false;
      errorObj.rateDate = "Date is required *";
    }
    setErrors(errorObj);
    const rateValue = parseFloat(rate);
    if (isNaN(rateValue)) {
      setErrors("Invalid rate value.");
      return;
    }
    setLoading(true);
    const formattedDate = rateDate && dayjs(rateDate).isValid()
    ? dayjs(rateDate).format("YYYY-MM-DD")
    : "";

    const bodyData ={
      id: rateId,
      productId : product,
      price: rate,
         date : formattedDate,
   
    }

    try {
      const response = await axios.put(RateMasterAdUpdate,bodyData );

      if (response.data === "UPDATED") {
        toast.success(' Updated successfully!');
        fetchRate();
        handleCancel();
      }
      else if (response.data === "ALREADYEXISTS") {
              toast.warn('Rate already exist!');
              handleCancel();
            }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while updating data');
    }
    finally{
      setLoading(false);
    }
  };

  // ========Delete data from table============
  const handleDeleteData = async (item) => {
      const confirmDelete = window.confirm(`Are you sure you want to delete ?`);
      if (!confirmDelete) return;

      try {
        const response = await axios.delete(`${RateMasterAdDelete}?id=${item.id}`);
        if (response.data === "DELETED") {
          toast.success('Rate deleted successfully!');
          fetchRate();
          handleCancel();
        }
      } catch (error) {
        console.error('Error during delete operation:', error);
        toast.error('Error occurred while deleting the stream');
      }
  };

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Edit",
      key: "Edit",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
          <span
              className='me-1 me-lg-2'
           type="submit"
          onClick={() => handleEditDataButton(record)}
            style={{
              fontSize: "12px",
              color: "orange",
            
            }}
          >
         <Tooltip title="Edit">   <i className="fa-solid fa-pen-to-square"></i></Tooltip>
          </span>
         
        </div>
      ),
    },
    {
      title: "Delete",
      key: "delete",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
       
          <span
              className='me-1 me-lg-2'
           type="submit"
          onClick={() => handleDeleteData(record)}
            style={{
              fontSize: "12px",
              color: "red",
             
            }}
          >
          <Tooltip title="Delete">  <i className="fa-solid fa-trash"></i></Tooltip>
          </span>
        </div>
      ),
    },
  ];

      //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================


  return (
    <>
     <AdminNavbar />
     
      <div className="p-0 m-0" >
        {/* Header Section */}
        <div className="row m-0" style={navbg}>
          <div className="col-12" style={{ display: "flex", alignItems: "center", justifyContent: "start",  }}>
          <span className="px-md-5" style={{ flexGrow: 1 }}>
      <AiFillAccountBook  /> &nbsp;
      Rate Master
    </span>

    {/* TitleNavbar (Right-aligned) */}
    <span>
      <TitleNavbar />
    </span>
          </div>
        </div>

        {/* Form Section */}
        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">

        

  {/* Date Input */}
  <div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-1 lableStyle">
        <label className="labels"  style={{fontSize:16}}>Date:</label>
      </div>
      <div className="col-9 col-lg-6">
     <DatePicker
  value={rateDate ? dayjs(rateDate) : null}  // Ensure value is a dayjs object or null
  onChange={(value) => setRateDate(value ? dayjs(value) : null)}  // Store value as a dayjs object
  className="w-100"
  format={dateFormatList}
/>

                        {errors.rateDate && (
                          <div className="errorField">{errors.rateDate}</div>
                        )}
      </div>
    </div>
  </div>

  <div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-1 lableStyle">
        <label className="labels"  style={{fontSize:16}}>Product:</label>
      </div>
      <div className="col-9 col-lg-6">
         <Select
                                value={product || undefined}
                                onChange={setProduct}
                                showSearch
                                className="w-100"
                                placeholder="Select Product"
                                optionFilterProp="children"
                              >
          {products.map(p => (
            <Select.Option key={p.id} value={p.id}>
              {p.productName}
            </Select.Option>
          ))}
        </Select>
        {errors.product && (
                          <div className="errorField">{errors.product}</div>
                        )}
      </div>
    </div>
  </div>
  {/* Rate Input */}
  <div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-1 lableStyle">
        <label className="labels"  style={{fontSize:16}}>Rate:</label>
      </div>
      <div className="col-9 col-lg-6">
        <Input 
                        value={rate}
                        onChange={(e) => setRate(e.target.value)}
                        className="w-100" placeholder="Enter Rate"
                        type="number" />
                         {errors.rate && (
                          <div className="errorField">{errors.rate}</div>
                        )}
      </div>
    </div>
  </div>





  <div className="col-12 text-center pt-3">
            <Button type="button"  onClick={handleCancel} className="CancelBtn mx-1" >
              Cancel
            </Button>
           {saveButton &&( <Button type="button" onClick={handleSubmit} className="SubmitBtn mx-1" 
             disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Save'}
            </Button>)}
            {updateButton&&(<Button type="button" onClick={handleUpdate} className="UpdateBtn mx-1"  disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Update'}
              
            </Button>)}
          </div>

          <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div>
        </div>
        </div></div>
        <div className='col-12 col-md-2 col-lg-4'></div>
        </div>

        {/*================ Table =========================*/}
                   <div className="row m-0 p-2 mb-5  pt-md-0 mt-3">
                   <div className='col-12 col-md-2'></div>
                     <div  className="col-12 col-md-8 py-3 shadow border"
                       style={{ marginBottom: "50px", backgroundColor: "white" }}
                     >
                       <div
                         className="col-12 px-md-5"
                         style={{ display: "flex", justifyContent: "space-between" }}
                       >
                         <div>
                           <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                           <Select
                             defaultValue={pageSize}
                             onChange={handlePageSizeChange}
                             style={{ width: 120, textAlign: "center" }}
                           >
                             <Option value={10}>10</Option>
                             <Option value={20}>20</Option>
                             <Option value={30}>30</Option>
                           </Select>
                         </div>
           
                         <div className="pt-4 pt-md-0">
                           <Input.Search
                             placeholder="Search"
                             onSearch={handleSearch}
                             style={{ width: 200, marginBottom: 16 }}
                           />
                         </div>
                       </div>
           
                       <div style={{ backgroundColor: "white" }}>
                         <Table
                           bordered
                           style={{ padding: "0px 20px", overflowX: "auto" }}
                           columns={columns}
                           dataSource={filteredData}
                           pagination={{
                             pageSize: pageSize,
                             total: totalEntries,
                             showTotal: (total, range) =>
                               `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                             current: currentPage,
                             onChange: (page) => setCurrentPage(page),
                           }}
                           showSorterTooltip={false}
                           rowKey={(record) => record.id}
                           components={components}
                         />
                       </div>
                     </div>
        </div>
      
    </>
  );
};

export default RateMaster;
